import { Button } from "../../../../components/ui";
import localization from "../../../../config/localization";
import { SignupMethodTypes } from "../../constants/signupMethodTypes";

type Method =
  | typeof SignupMethodTypes.Email
  | typeof SignupMethodTypes.Mobile
  | typeof SignupMethodTypes.OneClick
  | typeof SignupMethodTypes.WhatsApp;

interface SignupMethodSelectProps {
  handleSignupMethodClick: (method: Method) => void;
  allowedRegistrationMethods: string[];
}

const METHOD_CONFIG: Record<string, { icon: string; type: Method; key: string }> = {
  email: {
    icon: "/icons/ic-email.svg",
    type: SignupMethodTypes.Email,
    key: "email",
  },
  mobile: {
    icon: "/icons/ic-mobile.svg",
    type: SignupMethodTypes.Mobile,
    key: "phone",
  },
  oneclick: {
    icon: "/icons/ic-oneclick.svg",
    type: SignupMethodTypes.OneClick,
    key: "oneclick",
  },
  whatsapp: {
    icon: "/icons/ic-whatsapp.svg",
    type: SignupMethodTypes.WhatsApp,
    key: "whatsapp",
  },
};

export function SignupMethod({
  handleSignupMethodClick,
  allowedRegistrationMethods,
}: SignupMethodSelectProps) {

  const total = allowedRegistrationMethods?.length ?? 0;
  const isOdd = total % 2 !== 0;

  return (
    <div className="grid grid-cols-2 gap-4">
      {allowedRegistrationMethods?.map((method, index) => {
        const normalized = method.toLowerCase();
        const config =
          normalized.includes("whatsapp")
            ? METHOD_CONFIG.whatsapp
            : METHOD_CONFIG[normalized];

        if (!config) return null;

        const isLastItem = index === total - 1;
        const spanClass = isOdd && isLastItem ? "col-span-2" : "";

        return (
          <Button
            key={method}
            className={`bg-black border-[1.5px] border-[#242426] rounded-lg shadow flex flex-col items-center justify-center py-8 hover:bg-gray-900 transition ${spanClass}`}
            onClick={() => handleSignupMethodClick(config.type)}
          >
            <img src={config.icon} alt={method} />
            <span className="text-white mt-2 font-bold">
              {localization.getString(config.key)}
            </span>
          </Button>
        );
      })}
    </div>
  );
}